import React from 'react';
import {withRouter} from "react-router";
import { useLocation } from "react-router-dom";

import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import API from "@beardeddevops/react.api";
import ReCAPTCHA from "react-google-recaptcha";
import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Cookies from 'universal-cookie';

/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
class Login extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Accounts._name);
		this.model.requestType = API.RequestType.READ;
		this.recaptchaRef = React.createRef();
		this.brand = APPCONFIG.brand;
		this.shouldAutoLoad = false;
		this.state.password_confirm_error = '';
		const params = new URLSearchParams(window.location.search);
		this.isOnboarding = params.get("onboarding") === "true";
		this.initialEmail = params.get("email");
	}

	componentDidMount() {
		if (this.initialEmail && this.isOnboarding) {
			this.setState({email: this.initialEmail})
		}
	}

	handleSubmit = async (event) => {
		if (typeof event !== 'undefined') event.preventDefault();
		if (this.isOnboarding && this.initialEmail) {
			this.state.email = this.initialEmail;
		}
		if (this.state.password !== this.state.password_confirm && this.isOnboarding) {
			// API.Toast.error("Passwords must match!", {
			// 	position: API.Toast.POSITION.TOP_CENTER,
			// 	autoClose: 2000
			// });
			this.setState({password_confirm_error: 'Passwords must match!'})
			return;
		}
		// if (process.env.production) {
		// 	this.state.g_recaptcha_response = this.recaptchaRef.current.getValue();
		// 	console.log(this.state.g_recaptcha_response);
		// 	if (!this.state.g_recaptcha_response) {
		// 		return false;
		// 	}
		// }
		this.setState({loading: true});
		if (this.handleProcess(null, API.RequestType.READ)) {
			let data = await this.model.submit(this, API.RequestType.READ);
			let cookies = new Cookies();
			if (cookies.get('auth_pkey')) {
				cookies.remove('auth_pkey');
				cookies.remove('hash');
			}
			let expiry = new Date();
			expiry.setDate(expiry.getDate() + 14)
			cookies.set('auth_pkey', data.pkey ? data.pkey : data.email, {path: '/', expires: expiry});
			cookies.set('hash', data.secure_auth, {path: '/', expires: expiry});
			this.props.history.push('/dashboard');
		} else {
			this.setState({loading: false});
		}
		return false;
	}

	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.handleSubmit();
		}
	}

	handleVerify = (token) => {
		if (token.length > 0) {
			this.setState({verified: true})
		}
	}

	// onExpired(value) {
	// 	console.log("Captcha value:", value);
	// }
	//
	// onChange = value => {
	// 	console.log("Captcha value:", value);
	// };


	render() {
		let {properties} = this.model;
		/** @type {Accounts_Object} object */
		let object = this.state;
		let brand = this.brand;

		return (
			<div tabIndex={0}
			     onKeyDown={this.handleKeyPress}>
			<Card>
				<CardContent>
					<section className="logo text-center">
						<h1><a href="/">{brand}</a></h1>
					</section>

					<fieldset>
						<div className="form-group">
							<Framework.Elements.TextField
								value={this.isOnboarding && this.initialEmail ? this.initialEmail : object.email}
								error={object.email_error}
								property={properties.email}
								update={this.handleTextFieldPropertyUpdate}
								variant={"standard"}
								disabled={this.isOnboarding && !!this.initialEmail}
							/>
						</div>
						<br/>
						<div className="form-group">
							<Framework.Elements.TextField
								value={object.password}
								error={object.password_error}
								property={properties.password}
								label={this.isOnboarding ? "New Password" : "Password"}
								update={this.handleTextFieldPropertyUpdate}
								variant={"standard"}
								type={"password"}
							/>
						</div>
						<br/>
						{this.isOnboarding && <>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.password_confirm}
									error={object.password_confirm_error}
									label={"Confirm New Password"}
									property={properties.password_confirm}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
									type={"password"}
								/>
							</div>
							<br/>
						</>}
					</fieldset>
					{/*{process.env.production &&*/}
					{/*<div style={{textAlign: 'center', paddingTop: '10px'}}>*/}
					{/*	<ReCAPTCHA*/}
					{/*		ref={this.recaptchaRef}*/}
					{/*		sitekey="6LftwbcUAAAAAOz-h-DlbOGSQKzWFMQQc9K_GOF4"*/}
					{/*		onChange={this.onChange}*/}
					{/*		onExpired={this.onExpired.bind(this)}*/}
					{/*		style={{*/}
					{/*			display: 'inline-block'*/}
					{/*		}}*/}
					{/*	/>*/}
					{/*</div>}*/}
				</CardContent>
				<CardActions className={"d-flex justify-content-end mr-2"}>
					<Button onClick={this.handleSubmit} type={"submit"} id={"button-login"}
					        style={{marginLeft: "50px"}} color="primary" size={"md"}
					        block={false}>Login</Button>
				</CardActions>
			</Card>
			</div>
		);
	}
}

const LoginRoute = withRouter(Login);
const Page = () => (
	<div className="page-login">
		<div className="main-body">
			<div key="1">
				<LoginRoute/>
			</div>
		</div>
	</div>
);

export default Page;
